import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { i18n } from '../../../translate/i18n';
import { isEmpty, uniqueId } from 'lodash';
import filesize from "filesize";
import API from '../../../axios/api';
import axios from "axios";

import * as actions from "../../../store/actions";


import {
  Paper, Typography, FormControl, IconButton, Container, TextField, FormControlLabel, Switch, Button, useMediaQuery, Divider, FormLabel, RadioGroup, Radio, Avatar,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBack from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  FormStyled, DoneIconStyled, FormControlRadioStyled, DivSubmitButtons, DivFormTitle, DivSpinner,
} from './styles';

import { cnpjValidator, cnpjMask } from '../../../utils/cnpjValidator';

import confirm from '../../../UI/Confirm/confirm';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import PhotoUpload from '../../../UI/PhotoUpload';
import PhotoBarUploading from '../../../UI/PhotoBarUploading/PhotoBarUploading';
import ModalEditPhoto from '../../../UI/PhotoEditor/ModalEditor';
import Spinner from '../../../components/Spinner/index';
import { deleteCheckMessage } from '../../../utils/deleteCheckMessage';
import { EAccessRole } from '../../../store/types';

const FormCompany = (props) => {
  const dispatch = useDispatch();
  const matches = useMediaQuery('(min-width:1200px)');

  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(true);

  // parametros para busca do autocomplete
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  // forms do empresas
  const [name, setName] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [accountable, setAccountable] = useState("");
  const [email, setEmail] = useState("")
  const [blocked, setBlocked] = useState(false)
  const [phone, setPhone] = useState("")
  const [profile, setProfile] = useState([])
  const [tradingName, setTradingName] = useState("")


  const [modalPhoto, setModalPhoto] = useState();
  const [openModalAvatar, setOpenModalAvatar] = useState(false);

  //error forms
  const [nameError, setNameError] = useState(false);
  const [cnpjError, setCnpjError] = useState(false);
  const [cnpjInvalidError, setCnpjInvalidError] = useState(false);
  const [accountableError, setAccountableError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [profileError, setProfileError] = useState(false);

  // fetch from BE
  const fetchCompany = useCallback(
    () => dispatch(actions.fetchCompaniesById(props.match.params.id))
  );

  //get from redux
  const company = useSelector(state => state.companies.company);
  const loadingCompany = useSelector(state => state.companies.loading);
  const role = useSelector(state => state.auth.selectedAccess.role);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  const isAnalyst = role === EAccessRole.analyst;
  const isContractor = role === EAccessRole.contractor;
  const isInspector = selectedAccess.inspector && (isAnalyst || isContractor);

  //check if is newEntrance or editing
  useEffect(() => {
    setIsNewData(props.match.params.id === 'new')
    if (props.match.params.id !== 'new') {
      fetchCompany()
    } else {
      setName("")
      setCnpj("")
      setAccountable("")
      setEmail("")
      setPhone("")
      setBlocked(false)
    }
  }, [])

  // in case editing, populate fields
  useEffect(() => {
    if (!isEmpty(company) && props.match.params.id !== 'new') {
      setName(company.name)
      setCnpj(company.cnpj)
      setAccountable(company.accountable)
      setEmail(company.email)
      setPhone(company.phone)
      setBlocked(!!company.blocked)
      setTradingName(company.tradingName)
      const profileArray = []
      profileArray.push(company.photo)
      setProfile(profileArray)
    }
  }, [company])


  //send data to Server (post and update)
  const postCompanies = (body) => dispatch(actions.postCompanies(body))
  const updateCompanies = (body) => dispatch(actions.updateCompanies(props.match.params.id, body))
  const deleteCompanies = () => dispatch(actions.deleteCompanies(props.match.params.id))
  const checkDeleteCompanies = () => dispatch(actions.checkDeleteCompanies(props.match.params.id))


  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (!name) {
      setNameError(true);
      hasError = true
    }

    if (!cnpj) {
      setCnpjError(true);
      hasError = true
    }

    if (!accountable) {
      setAccountableError(true);
      hasError = true
    }

    if (cnpjInvalidError) {
      hasError = true
    }

    if (!email) {
      setEmailError(true);
      hasError = true
    }

    if (!phone) {
      setPhoneError(true);
      hasError = true
    }

    if (profile.length > 0 && profile[0]) {
      const notUploaded = profile.filter(fl => fl.uploaded === false)
      if (notUploaded.length > 0) {
        setProfileError(true)
        hasError = true;
      }
    }

    if (hasError) return

    const body = {
      "name": name,
      "cnpj": cnpj,
      "accountable": accountable,
      "phone": phone,
      "email": email,
      "tradingName": tradingName,
      "blocked": blocked
    }

    if (profile.length > 0 && profile[0] && (profile[0].id || profile[0]._id)) {
      body["photo"] = profile[0].id ? profile[0].id : profile[0]._id
    }

    if (isNewData) {
      postCompanies(body).then(result => {
        if (result === 'success') {
          props.history.goBack()
        }
      })
    } else {
      updateCompanies(body).then(result => {
        setEditMode(false)
      })
    }
  }

  const handleBack = () => {
    props.history.goBack()
  }

  const handleCloseComparison = () => {
    return ((name !== company.name) || (cnpj !== company.cnpj) || (accountable !== company.accountable) || (email !== company.email) || (phone !== company.phone) || (blocked !== !!company.blocked))
  }

  const handleCloseRestoreDefault = () => {
    setName(company.name)
    setCnpj(company.cnpj)
    setAccountable(company.accountable)
    setEmail(company.email)
    setPhone(company.phone)
    setBlocked(!!company.blocked)
  }

  const handleClose = () => {
    // verifica se algo foi alterado
    if (handleCloseComparison()) {
      confirm(i18n.t('handleCloseFormCompany.text'),
        {
          title: i18n.t('handleCloseFormCompany.title'),
          titleColor: 'red',
          disableBackdrop: true
        })
        .then(
          () => {
            console.log('continue editing');
          },
          async () => {
            handleCloseRestoreDefault();
            setEditMode(false)
          },
        )
    } else {
      setEditMode(false)
    }
  }

  const checkDeleteCompanyCall = () => {
    checkDeleteCompanies().then((res) => {
      if (isEmpty(res)) {
        handleDeleteCompany()
      } else {
        handleDeleteCompanyFail(res)
      }
    })
  }

  const handleDeleteCompany = () => {
    confirm(i18n.t('handleDeleteCompanyFormCompany.text'),
      {
        title: i18n.t('handleDeleteCompanyFormCompany.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteCompany()
        },
      )
  }

  const handleDeleteCompanyFail = (obj) => {
    confirm(`${deleteCheckMessage(obj)}`,
      {
        title: i18n.t('handleDeleteCompanyFailformCampany.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
        },
      )
  }

  const deleteCompany = () => {
    deleteCompanies().then(result => {
      if (result === 'success') {
        props.history.goBack()
      }
    })
  }

  const validateCnpjInput = (cnpjNow) => {
    const valid = cnpjValidator(cnpjNow);
    return valid;
  }

  const cnpjInputChange = event => {
    // setCnpjInvalidError(false)
    // setCnpjError(false);
    // if (event.target.value.length > 18) {
    //   setCnpj(event.target.value.slice(0, 18))
    // } else {
    //   setCnpj(cnpjMask(event.target.value));
    // }
    // if (event.target.value.length >= 18) {
    //   setCnpjInvalidError(!validateCnpjInput(event.target.value))
    // }
    setCnpjError(false);
    setCnpj(event.target.value)
  }

  const handleUploadPhoto = photo => {
    const uploadingFiles = photo.map(file => ({
      file,
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      fileType: file.type,
      uploaded: false,
      error: false,
      url: null
    }))

    // setProfile(uploadingFiles)
    // uploadingFiles.forEach(processUpload);
    setModalPhoto(uploadingFiles[0]);
    setOpenModalAvatar(true);

  }

  const handleCloseModalAvatar = (file) => {
    const uploadedFile = [];
    if (file) {
      uploadedFile.push({
        file,
        _id: uniqueId(),
        name: file.name,
        readableSize: filesize(file.size),
        preview: URL.createObjectURL(file),
        fileType: file.type,
        uploaded: false,
        error: false,
        url: null
      });
      setProfile(uploadedFile)
      processUpload(uploadedFile[0])
    }
    setOpenModalAvatar(false);
  }

  const updateFile = (id, data) => {
    console.log('id', id);
    console.log('data', data);

    setProfile(prevUf => {
      console.log('prevUf', prevUf);
      return prevUf.map(uf => id === uf._id ? { ...uf, ...data } : uf)
    })
  };


  const processUpload = async uploadedFile => {

    const payloadToSign = {
      fileType: uploadedFile.fileType,
      name: uploadedFile.name
    };

    API.post("photos/signurl", { file: payloadToSign }).then(signUrlRes => {
      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile._id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `profile/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType,
          source: 'web',
        }

        API.post("photos", body)
          .then(response => {
            setProfileError(false);
            updateFile(uploadedFile._id, {
              uploaded: true,
              _id: response.data._id,
              url: response.data.url
            });
          })
          .catch(() => {
            updateFile(uploadedFile._id, {
              error: true
            });
          });
      })
    })
  }



  return <>
    <ModalEditPhoto
      selectedFile={modalPhoto}
      open={openModalAvatar}
      onClose={handleCloseModalAvatar}
      title={i18n.t('modalEditPhotoFormCompany.title')}
    />
    <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
    <div style={matches ? styles.divContainer : styles.divContainerSmall}>
      <Container maxWidth='sm' style={styles.container}>
        {loadingCompany && <Spinner overlay />}
        <Paper>
          <FormStyled onSubmit={handleSubmit} style={{ opacity: loadingCompany ? '0.3' : '1' }}>
            <DivFormTitle>
              <Typography variant='h6'>{props.match.params.id === 'new' ? i18n.t('modalEditPhotoFormCompany.typographyTrue') : i18n.t('modalEditPhotoFormCompany.typographyFalse')}</Typography>
              {!isNewData &&
                <DivSubmitButtons>
                  {editMode ?
                    <>
                      <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                      <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                    </> :
                    <>
                      <IconButton disabled={isInspector} onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                      <IconButton disabled={isInspector} onClick={() => checkDeleteCompanyCall()} size="large"><DeleteIcon /></IconButton>
                    </>
                  }
                </DivSubmitButtons>
              }
            </DivFormTitle>
            <Divider />
            <>
              <div style={styles.photoContainer}>
                {!editMode && !isNewData && profile && !profile[0] ?
                  <Avatar style={styles.avatar}>{i18n.t('avatarFormCompany.logo')}</Avatar>
                  : (<>
                    <PhotoUpload onUpload={handleUploadPhoto} photo={profile} enabled={editMode || isNewData} />
                    <PhotoBarUploading photo={profile} />
                    {profileError ? <Typography style={{ color: "#f44336" }}>{i18n.t('avatarFormCompany.Typography')}</Typography> : null}
                  </>)}
              </div>
              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode}
                  label={i18n.t('textFieldFormCompany.name')}
                  name='empresa'
                  onChange={event => { setNameError(false); return setName(event.target.value.toUpperCase()) }}
                  value={name}
                  error={nameError}
                  margin='normal' />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode}
                  label={i18n.t('textFieldFormCompany.tradingName')}
                  name='tradingName'
                  onChange={event => { return setTradingName(event.target.value.toUpperCase()) }}
                  value={tradingName}
                  margin='normal' />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode}
                  label={i18n.t('textFieldFormCompany.cnpj')}
                  name='cnpj'
                  onChange={event => cnpjInputChange(event)}
                  value={cnpj}
                  error={cnpjError}
                  margin='normal' />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode}
                  label={i18n.t('textFieldFormCompany.email')}
                  name='email'
                  onChange={event => { setEmailError(false); return setEmail(event.target.value) }}
                  value={email}
                  error={emailError}
                  margin='normal' />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode}
                  label={i18n.t('textFieldFormCompany.accountable')}
                  name='responsavel'
                  onChange={event => { setAccountableError(false); return setAccountable(event.target.value.toUpperCase()) }}
                  value={accountable}
                  error={accountableError}
                  margin='normal' />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode}
                  label={i18n.t('textFieldFormCompany.phone')}
                  name='telefones'
                  onChange={event => { setPhoneError(false); return setPhone(event.target.value) }}
                  value={phone}
                  type='phone'
                  error={phoneError}
                  margin='normal' />
              </FormControl>
{/*
              <FormControl margin='normal'>
                <FormControlLabel
                  control={
                    <Switch
                      disabled={!isNewData && !editMode}
                      name='bloqueada'
                      checked={blocked}
                      onChange={event => setBlocked(event.target.checked)}
                      color="primary"
                    />
                  }
                  label="Bloquear Empresa"
                />
              </FormControl> */}
            </>
            {isNewData &&
              <DivSubmitButtons>
                <IconButton onClick={props.history.goBack} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
                <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
              </DivSubmitButtons>}
          </FormStyled>
        </Paper>
      </Container>
    </div>
  </>;
}

export default FormCompany;


const styles = {
  arrowBack: {
    position: 'fixed',
    marginTop: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 195,
    height: 195,
    marginTop: 20
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  photoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
}


